package ui.app.assign.detail.wheel.preview.pages

import androidx.compose.foundation.VerticalScrollbar
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.rememberScrollbarAdapter
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import api.ResourceType
import ui.app.assign.detail.wheel.preview.AppPreviewWheelScope
import ui.widget.LazyIcon
import ui.widget.LazyImage
import ui.widget.Space

@Composable
fun AppPreviewWheelScope.AppWheelItems(nnvl: AppPreviewWheelScope.Wrapper, modifier: Modifier) {
    val state = rememberLazyListState()
    Box(modifier.fillMaxSize()) {
        LazyColumn(
            modifier = Modifier.fillMaxSize(),
            verticalArrangement = Arrangement.spacedBy(4.dp),
            contentPadding = PaddingValues(8.dp)
        ) {
            items(nnvl.items.state) {
                Item(it)
            }
        }
        VerticalScrollbar(
            modifier = Modifier.fillMaxHeight()
                .align(Alignment.CenterEnd)
                .padding(2.dp),
            adapter = rememberScrollbarAdapter(state)
        )
    }
}

@Composable
private fun AppPreviewWheelScope.Item(item: AppPreviewWheelScope.ItemsWrapper.Item) {
    Row(
        horizontalArrangement = Arrangement.spacedBy(8.dp),
        modifier = Modifier.background(Color(item.data.color.surface))
            .padding(8.dp)
    ) {

        when {
            item.data.icon.svg != ResourceType.NO_ICON -> {
                LazyIcon(
                    id = item.data.icon.svg,
                    modifier = Modifier.size(32.dp).align(Alignment.CenterVertically),
                    tint = Color(item.data.color.onSurface)
                )
            }

            item.data.icon.webp != ResourceType.NO_IMAGE -> {
                LazyImage(
                    id = item.data.icon.webp,
                    modifier = Modifier.size(32.dp).align(Alignment.CenterVertically),
                    alphaBackground = false
                )
            }
        }
        Text(
            text = item.data.name,
            style = MaterialTheme.typography.bodyMedium,
            color = Color(item.data.color.onSurface),
            modifier = Modifier.align(Alignment.CenterVertically)
                .padding(2.dp)
                .weight(1F)
        )
        Space(8.dp)
        Text(
            text = "${item.data.count - item.data.used} / ${item.data.count}",
            style = MaterialTheme.typography.bodyLarge,
            color = Color(item.data.color.onSurface),
            fontWeight = FontWeight.Bold,
            modifier = Modifier.align(Alignment.CenterVertically)
                .padding(8.dp)
        )
    }
}